import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg, todayRome } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/common";

const EMPTY = { date: todayRome(), orario: "", pet_name: "", owner_name: "", pickup_address: "" };

export const AppuntamentoDialog = ({ open, onOpenChange, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ ...EMPTY, date: todayRome() }); }, [open]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async () => {
    if (!f.pet_name.trim()) return toast.error("Il titolo è obbligatorio");
    setBusy(true);
    try {
      await api.post("/admin/bookings", { ...f, date: f.date || todayRome(), kind: "promemoria", service_type: "singola", species: "", notes: "" });
      toast.success("Appuntamento aggiunto in agenda"); onSaved?.(); onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl bg-[#FAF8F5]" data-testid="appuntamento-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#0D3B52]">Nuovo appuntamento / promemoria</DialogTitle>
          <DialogDescription>Solo il titolo è obbligatorio.</DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Titolo *" className="sm:col-span-2"><Input value={f.pet_name} onChange={set("pet_name")} placeholder="Es. Chiamare veterinario, pagare impianto, ritirare urne…" className="bg-white" data-testid="prom-title" /></Field>
          <Field label="Giorno"><Input type="date" value={f.date} onChange={set("date")} className="bg-white" data-testid="prom-date" /></Field>
          <Field label="Orario"><Input type="time" value={f.orario} onChange={set("orario")} className="bg-white" data-testid="prom-orario" /></Field>
          <Field label="Indirizzo"><Input value={f.pickup_address} onChange={set("pickup_address")} className="bg-white" data-testid="prom-address" /></Field>
          <Field label="Referente"><Input value={f.owner_name} onChange={set("owner_name")} className="bg-white" data-testid="prom-owner" /></Field>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-full">Annulla</Button>
          <Button onClick={save} disabled={busy} data-testid="prom-save" className="rounded-full bg-[#0D3B52] hover:bg-[#082535]">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva appuntamento"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
